'use strict';

var common = require('../common');
var joinSchemeLogin = require('../savingSchemes/joinSchemeLogin');

let index = 0;
let total = $('.marquee-span').length;
let height = $('.marquee-span').outerHeight();

/**
 * Scrolls the promotion banner slider to the next item.
 */
function scrollDivs() {
    index += 1;

    if (index >= total) {
        $('.py-promo-slider').css('transform', 'translateY(0)');
        $('.marquee-span').removeClass('active');
        $('.marquee-span').eq(0).addClass('active');
        index = 0;
    } else {
        $('.py-promo-slider').css('transform', `translateY(-${index * height}px)`);
        $('.marquee-span').removeClass('active');
        $('.marquee-span').eq(index).addClass('active');
    }
}

let lastScroll = 0;
const navWrapper = document.querySelector('.sticky-nav');

window.addEventListener('scroll', () => {
    const viewportWidth = document.documentElement.clientWidth;
    // Only run if screen width is above 992px
    if (viewportWidth <= 992) {
        navWrapper.classList.remove('scroll-up', 'scroll-down', 'd-none');
        return;
    }

    const currentScroll = window.pageYOffset;

    if (currentScroll <= 0) {
        // Always make nav visible when at the very top
        navWrapper.classList.remove('scroll-down', 'd-none');
        navWrapper.classList.add('scroll-up');
        return;
    }

    if (currentScroll > lastScroll && !navWrapper.classList.contains('scroll-down')) {
        // Scrolling down → hide nav
        navWrapper.classList.remove('scroll-up');
        navWrapper.classList.add('scroll-down', 'd-none');
    } else if (currentScroll < lastScroll && navWrapper.classList.contains('scroll-down')) {
        // Scrolling up → show nav
        navWrapper.classList.remove('scroll-down', 'd-none');
        navWrapper.classList.add('scroll-up');
    }

    lastScroll = currentScroll;
});

/**
 * Organizes a list of category elements into a series of columns based on the number of items. This is a special case for the Pothys layout.
 * @function organizeDivs
 * @param {jQuery} $parentElement - The element containing the category elements.
 */
function organizeDivs($parentElement) {
    var container = $parentElement.find('.categories-section');
    container.addClass('flex-column');
    var items = container.find('.l2-category:not(.category-link)').detach(); // Remove items but retain events
    var linkItems = container.find('.l2-category.category-link').detach();
    var itemCount = items.length;
    var itemLinksCount = linkItems.length;

    if (itemCount === 0 && itemLinksCount === 0) return; // Avoid duplicate processing

    container.empty();

    if (itemCount > 0) {
        var parents = [];
        if (itemCount <= 3) {
            for (var i = 0; i < itemCount; i += 1) {
                let parent = $("<div class='category-column'></div>").append(items.eq(i));
                parents.push(parent);
            }
        } else if (itemCount === 4) {
            // Case: 4 divs → First 2 divs in 1 parent, then 1 per parent
            let parent1 = $("<div class='category-column'></div>").append(items.eq(0), items.eq(1));
            let parent2 = $("<div class='category-column'></div>").append(items.eq(2));
            let parent3 = $("<div class='category-column'></div>").append(items.eq(3));
            parents.push(parent1, parent2, parent3);
        } else if (itemCount === 5) {
            // Case: 5 divs → (1,2) in 1st, (3,4) in 2nd, (5) in 3rd
            let parent1 = $("<div class='category-column'></div>").append(items.eq(0), items.eq(1));
            let parent2 = $("<div class='category-column'></div>").append(items.eq(2), items.eq(3));
            let parent3 = $("<div class='category-column'></div>").append(items.eq(4));
            parents.push(parent1, parent2, parent3);
        } else if (itemCount === 6) {
            // Case: 6 divs → (1,2) in 1st, (3,4) in 2nd, (5,6) in 3rd
            let parent1 = $("<div class='category-column'></div>").append(items.eq(0), items.eq(1));
            let parent2 = $("<div class='category-column'></div>").append(items.eq(2), items.eq(3));
            let parent3 = $("<div class='category-column'></div>").append(items.eq(4), items.eq(5));
            parents.push(parent1, parent2, parent3);
        }
        container.append(parents); // Append all parents to the container
    }

    // Append category-link items separately
    if (itemLinksCount > 0) {
        container.append($("<div class='category-column'></div>").append(linkItems));
    }
}

$('.nav-item.lg-mega-menu:not(.no-subcategory)').on('mouseenter touchstart', function () {
    $('body').append('<div class="megamenu-backdrop"></div>');
    organizeDivs($(this));
}).on('mouseleave touchend', function () {
    $('.megamenu-backdrop').remove();
});

$(document).on('click', '.s-vc-cta', function (e) {
    e.preventDefault();
    var isloggedInUser = $('.isLoggedInUser').val() === 'true';
    if (!isloggedInUser) {
        if ($('#signUpButton').length > 0) {
            $('#loginPopupModal').modal('show');
            window.redirectToLiveShoppingPage = true;
        }
    } else {
        const redirectUrl = $('#live-shopping-url').val();
        window.location.href = redirectUrl;
    }
});

$(document).on('click', '.whishlist-login', function (e) {
    e.preventDefault();
    var isloggedInUser = $('.isLoggedInUser').val() === 'true';
    if (!isloggedInUser) {
        if ($('#signUpButton').length > 0) {
            $('#loginPopupModal').modal('show');
            window.isWishlistRedirect = true;
        }
    } else {
        var wishlistUrl = $(this).data('url');
        window.location.href = wishlistUrl;
    }
});

common.openLoginSignupModal('#signUpButton');

$(document).ready(function () {
    $('#book-appointment-btn').removeAttr('data-toggle').removeAttr('data-target');

    $(document).on('click', '#book-appointment-btn', function (e) {
        e.preventDefault();
        const isAuthenticated = $('#customer-authenticated').val() === 'true';

        if (isAuthenticated) {
            $('#book-appointment-modal').modal('show');
            $('#book-appointment-btn').attr('data-toggle', 'modal').attr('data-target', '#book-appointment-modal');
        } else {
            $('#loginPopupModal').modal('show');
            sessionStorage.setItem('openBookAppointmentAfterLogin', 'true');
            $('#loginPopupModal').data('bookAppointmentInitiator', true);
        }
    });

    var VirtualTryOnClickedData = JSON.parse(localStorage.getItem('virtualTryOnOpen'));
    if (VirtualTryOnClickedData && VirtualTryOnClickedData.triggered) {
        var isAuthenticated = $('#customer-authenticated').val() === 'true';
        if (isAuthenticated) {
            // If tryItOn exposes a resume helper, use it; otherwise fallback to triggering the original button
            if (typeof window.resumeVirtualTryOn === 'function') {
                window.resumeVirtualTryOn(VirtualTryOnClickedData);
            } else {
                var targetButton = $('.' + VirtualTryOnClickedData.clickedClass);
                if (targetButton.length) targetButton.trigger('click');
            }
        }
        // if not authenticated, keep the localStorage entry so login flow can continue to handle it
    }
});

$(document).ready(function () {
    $('.video-call-cta').removeAttr('data-toggle').removeAttr('data-target');

    $(document).on('click', '.video-call-cta', function (e) {
        e.preventDefault();
        const isAuthenticated = $('#customer-authenticated').val() === 'true';

        if (isAuthenticated) {
            $('#videoCallModel').modal('show');
            $('.video-call-cta').attr('data-toggle', 'modal').attr('data-target', '#videoCallModel');
        } else {
            $('#loginPopupModal').modal('show');
        }
    });
});

$(document).ready(function () {
    setInterval(scrollDivs, 5000);

    $('.login-signup-cta').click(function () {
        if ($('.login-signup-cta').closest('.main-menu').hasClass('show-mobile-menu')) {
            $('.mb-close-menu-button').trigger('click');
        }
    });
    $('#signUpButton').on('click', function (e) {
        e.preventDefault();
        if ($('#customer-authenticated').val() !== 'true') {
            $('#loginPopupModal').modal('show');
        } else {
            window.location.assign($(this).attr('href'));
        }
    });
});

// On page load after login, open book appointment modal if requested before login
$(document).ready(function () {
    const openAfterLogin = sessionStorage.getItem('openBookAppointmentAfterLogin');
    if (openAfterLogin === 'true') {
        sessionStorage.removeItem('openBookAppointmentAfterLogin');
        const isAuthenticated = $('#customer-authenticated').val() === 'true';
        if (isAuthenticated) {
            $('#book-appointment-modal').modal('show');
            $('#book-appointment-btn').attr('data-toggle', 'modal').attr('data-target', '#book-appointment-modal');
        }
    }
});

// If the login modal is closed manually and it was opened by the book-appointment flow,
// clear the session flag to avoid opening the appointment modal when login happens elsewhere.
$(document).on('hidden.bs.modal', '#loginPopupModal', function () {
    // remove window.redirectToLiveShoppingPage = true; this also handles that case
    if (window.redirectToLiveShoppingPage) {
        window.redirectToLiveShoppingPage = false;
    }
    if (window.redirectToSavingSchemePage) {
        window.redirectToSavingSchemePage = false;
    }
    window.redirectToJoinScheme = null;
    if ($(this).data('bookAppointmentInitiator')) {
        sessionStorage.removeItem('openBookAppointmentAfterLogin');
        $(this).removeData('bookAppointmentInitiator');
    }
});

$(document).on('click', '.plp-login-banner', function (e) {
    e.preventDefault();
    const isAuthenticated = $('#customer-authenticated').val() === 'true';
    if (!isAuthenticated) {
        $('#loginPopupModal').modal('show');
    }
});

// Joining a scheme needs a logged in customer: log in first, then continue to the join form
$(document).on('click', '.js-join-scheme-cta', function (e) {
    if (joinSchemeLogin.isLoggedIn()) {
        return;
    }
    e.preventDefault();
    joinSchemeLogin.loginAndContinue({
        scheme: $(this).data('scheme'),
        type: 'NEW'
    }, $(this).attr('href'));
});

// A logged out shopper who opened the join form is sent here with the login popup to open
$(document).ready(function () {
    var params = new URLSearchParams(window.location.search);
    if (params.get('login') === 'joinScheme' && !joinSchemeLogin.isLoggedIn()) {
        joinSchemeLogin.loginAndContinue(true);
    }
});

$(document).on('click', '.saving-manage-scheme, .monthly-investment-cta', function (e) {
    e.preventDefault();
    var isloggedInUser = $('.isLoggedInUser').val() === 'true';
    if (!isloggedInUser) {
        if ($('#signUpButton').length > 0) {
            $('#loginPopupModal').modal('show');
            window.redirectToSavingSchemePage = true;
        }
    } else {
        const redirectUrl = $('.saving-scheme-url').val();
        window.location.href = redirectUrl;
    }
});
